<section class="termos-section">
  <div class="termos-container">

    <h2>Termos de Uso</h2>

    <p class="data">
      Data de disponibilização: 07/07/2025 | Versão 1.0
    </p>

    <p>
      Bem-vindo ao <strong>CuidaZap!</strong> Somos um serviço digital que conecta
      familiares e cuidadores a idosos por meio de mensagens simples e humanizadas
      no WhatsApp. Por aqui, ajudamos a lembrar horários de remédios e consultas,
      oferecemos companhia com mensagens carinhosas e acionamos um contato de
      confiança quando o idoso precisa de ajuda.
    </p>

    <p>
      Estes Termos e Condições de Uso ("Termos") regulam o uso do serviço CuidaZap,
      mantido por <strong>CIT SISTEMAS</strong>, inscrita no CNPJ/MF sob o nº
      <strong>31.711.107/0001-71</strong>, com sede na cidade de Trindade/GO.
      Ao utilizar nossos serviços, você concorda com os termos abaixo.
    </p>

    <h3>DEFINIÇÕES</h3>

    <ul>
      <li>
        <strong>Usuário:</strong> Pessoa física que utiliza o CuidaZap, podendo
        ser um idoso assistido ou um familiar/cadastrante.
      </li>

      <li>
        <strong>Assistido:</strong> Pessoa idosa cadastrada para receber
        mensagens e lembretes.
      </li>

      <li>
        <strong>Contato de emergência:</strong> Pessoa indicada para ser
        notificada quando o assistido pedir ajuda.
      </li>

      <li>
        <strong>Plataforma:</strong> Sistema operado pelo CuidaZap, incluindo
        o agente de WhatsApp, site e APIs relacionadas.
      </li>
    </ul>

    <h3>SERVIÇOS OFERECIDOS</h3>

    <p>
      O CuidaZap oferece um serviço automatizado via WhatsApp, que inclui:
    </p>

    <ul>
      <li>Envio de lembretes de remédios e consultas;</li>
      <li>Mensagens carinhosas de bom dia, boa noite e companhia;</li>
      <li>
        Encaminhamento de pedidos de ajuda para um familiar ou cuidador indicado.
      </li>
    </ul>

    <p>
      O serviço é voltado para apoio cotidiano e bem-estar. O CuidaZap não
      substitui serviços médicos, emergenciais ou de saúde.
    </p>

    <h3>CADASTRO</h3>

    <p>
      Para usar o CuidaZap, é necessário preencher um formulário online com as
      seguintes informações:
    </p>

    <ul>
      <li>Nome do idoso assistido;</li>
      <li>Contato do assistido (número de WhatsApp);</li>
      <li>Horários de remédio ou eventos;</li>
      <li>Nome e telefone do contato de emergência.</li>
    </ul>

    <p>
      Ao enviar o formulário, o usuário declara que tem autorização do idoso
      (ou é o próprio) para ativar o serviço.
    </p>

    <h3>OBRIGAÇÕES DO USUÁRIO</h3>

    <ul>
      <li>Fornecer dados corretos e atualizados;</li>

      <li>
        Respeitar os termos deste documento e a legislação aplicável;
      </li>

      <li>
        Avisar o CuidaZap caso o número de telefone do assistido ou do contato
        de emergência mude.
      </li>
    </ul>

    <h3>LIMITAÇÕES DO SERVIÇO</h3>

    <ul>
      <li>
        O CuidaZap depende de conectividade com a internet e do correto
        funcionamento do WhatsApp para operar.
      </li>

      <li>
        Mensagens podem não ser entregues em tempo real caso o WhatsApp do
        usuário esteja desligado, sem internet ou bloqueado.
      </li>

      <li>
        O CuidaZap não realiza chamadas de emergência, apenas envia mensagens
        ao contato indicado.
      </li>
    </ul>

    <h3>PRIVACIDADE E DADOS PESSOAIS</h3>

    <p>
      A Política de Privacidade do CuidaZap, que é parte integrante destes
      Termos, informa como coletamos, usamos, armazenamos e protegemos seus
      dados, em conformidade com a LGPD (Lei Geral de Proteção de Dados –
      Lei nº 13.709/18).
    </p>

    <h3>PROPRIEDADE INTELECTUAL</h3>

    <p>
      Todos os direitos da marca, layout, conteúdo e tecnologia da plataforma
      CuidaZap são de titularidade da <strong>CIT Sistemas</strong>. É vedada
      sua reprodução, cópia ou uso sem autorização por escrito.
    </p>

    <h3>ENCERRAMENTO DO SERVIÇO</h3>

    <p>
      Você pode solicitar a interrupção do serviço a qualquer momento, enviando
      um e-mail para <strong>contato@cuidazap.com</strong> ou acessando a
      página oficial.
    </p>

    <p>
      Reservamo-nos o direito de suspender ou encerrar o serviço caso sejam
      identificadas condutas indevidas, fornecimento de informações falsas ou
      uso em desconformidade com os presentes termos.
    </p>

    <h3>MODIFICAÇÕES DOS TERMOS</h3>

    <p>
      O CuidaZap poderá alterar estes Termos a qualquer momento. Sempre que
      isso acontecer, notificaremos os usuários cadastrados. O uso contínuo
      do serviço após tais alterações será interpretado como concordância com
      os novos termos.
    </p>

    <h3>LEGISLAÇÃO APLICÁVEL E FORO</h3>

    <p>
      Estes Termos são regidos pelas leis da República Federativa do Brasil.
      Fica eleito o foro da comarca de São Paulo/SP para resolução de quaisquer
      conflitos decorrentes da utilização dos serviços CuidaZap.
    </p>

    <h3>CONTATO</h3>

    <p>
      Em caso de dúvidas, sugestões ou solicitações, entre em contato com:
      <strong>E-mail: contato@cuidazap.com</strong>
    </p>

    <p class="final-destaque">
      Estamos aqui para cuidar de quem você ama 💚
    </p>

  </div>
</section>
